import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import AuthContext from "@contexts/auth-context";
import React, { useContext, useEffect } from "react";
var DiseaseProfile = function(param) {
    var disease = param.disease;
    var currentUser = useContext(AuthContext);
    useEffect(function() {
        if (!currentUser) {
            window.location.href = "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/marketing");
        }
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        isResultPage: true,
        profileData: disease,
        type: "diseases"
    });
};
export var __N_SSG = true;
export default DiseaseProfile;
